import client from 'services/networking/client';
import type { B2bRoom } from 'shared-types/b2bRoom';

export const getB2bRoomUuid = async (roomId: string): Promise<B2bRoom> =>
  client.get(`/b2b-rooms/${roomId}`);

export const connectB2bRoom = async (uuid: string): Promise<void> =>
  client.patch(`/b2b-rooms/${uuid}/connect`, {});

export const disconnectB2bRoom = async (uuid: string): Promise<void> =>
  client.patch(`/b2b-rooms/${uuid}/disconnect`, {});

export const checkStaffPassword = async (password: string): Promise<boolean> =>
  client.post('/b2b-rooms/check-staff-password', { password });

export const toggleSkipStaffPassword = async (shouldSkipPassword: boolean): Promise<void> =>
  client.post('/b2b-rooms/toggle-Skip-Staff-Password', { shouldSkipPassword });

export const getUserUuid = async (roomUuid: string) => {
  return await fetch(`${process.env.REACT_APP_API_BASE_URL}/b2b-rooms/${roomUuid}/userId`).then(
    (response) => response.json(),
  );
};

export const getUser = async (roomUuid: string) => {
  return await fetch(`${process.env.REACT_APP_API_BASE_URL}/b2b-rooms/${roomUuid}/user`).then(
    (response) => response.json(),
  );
};
